// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"138":"profile","249":"views-home","687":"create"}[chunkId] || chunkId) + "." + {"138":"dec4f0b4","249":"4359fae6","687":"334035a7","891":"eb6db0f7"}[chunkId] + ".chunk.css";
};